export default "__VITE_ASSET__Dx4IGLfd__"